import React, { useEffect, useState } from "react";
import { collection, query, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { doc, deleteDoc } from "firebase/firestore";
import { Link } from "react-router-dom";

const ResultShowTerm1 = () => {
    const [list, setList] = useState([]);
    const [standard,setStandard] = useState("");
    const [classSection,setClassSection] = useState("");
  
  
    useEffect(() => {
      const q = query(collection(db, "resultStudent"));
      onSnapshot(q, (querySnapshot) => {
        let studentResultArray = [];
        querySnapshot.forEach((doc) => {
          studentResultArray.push({ id: doc.id, ...doc.data() });
        });
        setList(studentResultArray);
      });
    }, []);
  
    let tempArr=[]
        tempArr=(list?.filter((item) => item?.studied === standard && item?.classSection === classSection));
  
    const deleteResultField = async (rid) => {
      await deleteDoc(doc(db, "resultStudent", rid));
      console.log("Deleted ===>" + rid);
    };
  return (
    <div className="p-5  min-h-screen">
    <div className="grid grid-cols-3  pl-5 pr-5 ">
    <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/4">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Class
                    </label>
                  </div>
                  <div className="md:w-1/2">
                  <select
                       value={standard}
                       onChange={(e) => {
                      setStandard(e.target.value);
                               }}
                   className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                       >
                         <option value="null"> select</option>
                      <option value="1">Class I</option>
                      <option value="2">Class II</option>
                      <option value="3">Class III</option>
                      <option value="4">Class IV</option>
                      <option value="5">Class V</option>
                      <option value="6">Class VI</option>
                      <option value="7">Class VII</option>
                      <option value="8">Class VIII</option>
                      <option value="9">Class IX</option>
                      <option value="10">Class X</option>
                      <option value="11">Class XI</option>
                      <option value="12">Class XII</option>
                  </select>
                  </div>
                </div>
              </div>
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/4">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Section
                    </label>
                    </div>
                    <div className="md:w-1/2">
                   <select
                   value={classSection}
                   onChange={(e) => {
                  setClassSection(e.target.value);
                           }}
              className="form-select  block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                       <option value="null"> select</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                      <option value="D">D</option>
                      <option value="E">E</option>
                      <option value="F">F</option>
                    </select></div></div></div>
             
            </div>
         <div className="w-full p-5 text-gray-700">
        <table className="w-full  text-center">
          <thead className="border-b  ">
            <tr className="bg-gray-100">
              <th className="py-3 ">Sl No.</th>
              <th className="py-3 ">Class</th>
              <th className="py-3 ">Roll No. </th>
              <th className="py-3 ">Id</th>
              <th className="py-3 ">Name</th>
              <th className="py-3 ">Academic session</th>
              <th className="py-3 ">View</th>
              <th className="py-3 ">Update</th>
              <th className="py-3 ">Delete</th>
            </tr>
          </thead>
          
          <tbody>
            {tempArr?.map((item, index) => (
              <tr className="border-b" key={index}>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {++index}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.studied}/{item.classSection}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.classRollNumber}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.studentIdNumber}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.studentName}
                </td>
                <td className="py-3 px-2 text-sm font-medium text-gray-900 border-r">
                  {item.academicSession}
                </td>
                <td className="py-3 px-5 text-sm font-medium text-gray-900 border-r">
                  <Link to={"../resultDownload"} state={{ resultId: item.id }}>
                    <div className="text-white bg-yellow-600 py-1 px-1 rounded-md">
                      View
                    </div>
                  </Link>
                </td>
                <td className="py-3 px-5 text-sm font-medium text-gray-900 border-r">
                  <Link to={"../resultUpdate"} state={{ resultId: item.id }}>
                    <div className="text-white bg-green-600 py-1 px-1 rounded-md">
                      Update
                    </div>
                  </Link>
                </td>

                <td className="py-3 px-5 text-sm font-medium text-gray-900 border-r">
                  <button
                    className="text-white bg-red-600 py-1 px-1 rounded-md "
                    onClick={() => deleteResultField(item.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ResultShowTerm1